import { Component, HostBinding, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mu-section-title',
  templateUrl: './mu-section-title.component.html',
  styleUrls: ['./mu-section-title.component.sass'],
})
export class MuSectionTitleComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() icon: string;
  @Input() removeItem: number;
  @HostBinding('attr.title') attrTitle = '';
  subTitleList: { [key: string]: string }[] = [];

  constructor(private translateService: TranslateService, private activatedRoute: ActivatedRoute) {
    /** */
  }

  ngOnInit(): void {
    if (!this.title) {
      this.title = 'context.title';
    }
    this.populateSubtitles();
  }

  ngOnChanges(): void {
    this.populateSubtitles();
  }

  /**
   * Fill subtitle list or use subtitle property
   */
  populateSubtitles() {
    this.subTitleList = [];
    const list = Object.assign({}, this.activatedRoute.routeConfig.data, history.state || {});
    history.replaceState({}, '');
    const labelList = (list.breadcrumb as string)?.split('/') || [];
    if ((!labelList || labelList.length === 0) && this.subTitle) {
      this.subTitleList.push({ label: this.translateService.instant(this.subTitle) });
      return environment.guardClause;
    }
    for (const label of labelList) {
      this.subTitleList.push({ label: this.translateService.instant('breadcrumb.' + label) });
    }
  }
}
